import Badge from 'zarm/lib/badge';

Badge.defaultProps.prefixCls = 'zw-badge';

export default Badge;
